'use client';
import React from 'react';
import { usePermission } from './usePermission';
import { getValueFromCookie } from '@benzinga/utils';

export const useIsUserBenzingaContributor = (): boolean => {
  const isBenzingaContributor = usePermission('cms/role', 'Benzinga Contributor');

  const [hasAccess, setHasAccess] = React.useState(isBenzingaContributor);
  React.useEffect(() => {
    if (getValueFromCookie('bz_edit')) {
      setHasAccess(true);
    } else if (typeof window !== 'undefined') {
      if (isBenzingaContributor) {
        window.localStorage.setItem('cms/role_contributor', '1');
      }
      const authorized = window.localStorage && window.localStorage.getItem('cms/role_contributor') ? true : false;
      setHasAccess(authorized);
    }
  }, [isBenzingaContributor]);
  return hasAccess;
};
